import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RocketIcon = _resolveComponent("RocketIcon")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dots" }, [
          _createElementVNode("span", { class: "dot dot1" }, "."),
          _createElementVNode("span", { class: "dot dot2" }, "."),
          _createElementVNode("span", { class: "dot dot3" }, ".")
        ], -1)),
        _createVNode(_component_RocketIcon)
      ]))
    : _createCommentVNode("", true)
}